import React, { useState, useEffect } from "react";
import styles from "./styles.module.css"

const Carouser = ({ images = [] }) => {
    const [currentIndex, setCurrentIndex] = useState(0);
    console.log('currentIndex:', currentIndex)
    useEffect(() => {
        const timer = setInterval(() => {
            setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
        }, 3000); // Change image every 3 seconds (adjust as needed)

        return () => clearInterval(timer);
    }, [images]);
    return (
        <div className={styles.carousel_container}>
            <div className={styles.carousel}>

                <img
                    src={images[currentIndex]}
                    alt=""
                    className={`${styles.carousel_slide}`}
                />

            </div>
            <div className={styles.carousel_indicator}>
                {images.length > 0 && images.map((_, index) => (
                    <div
                        key={index}
                        className={styles.indicator}
                        id={index === currentIndex ? styles.active : ""}
                    ></div>
                ))}
            </div>
        </div>
    )
}

export default Carouser